import React, { useState } from 'react';
// import { useEffect } from 'react';
import { FaUsers, FaClock } from "react-icons/fa";
// import { useNavigate } from 'react-router-dom';
import { MdArrowDropDownCircle } from "react-icons/md";
import { IoMdArrowDropupCircle } from "react-icons/io";
import panelImg from '../Assests/panel.png';
import Zaid from '../Assests/Zaid_Mahmud.png';
import Asfak from '../Assests/Asfak_Ali.jpg';
import Diptarka from '../Assests/Diptarka_Mondal.png';
import Kaustav from '../Assests/Kaustav_Das1.jpeg';
import Sayan from '../Assests/Sayan_Ganguly.jpeg';
import Udathya from '../Assests/Udathya_Aich.jpg';
import Urnisha from '../Assests/Urnisha_Pal.jpeg';
import Sristi from '../Assests/SRISTI_logo.png';

const scheduleData = [
    { date: "14th Mar 2025", time: "00:00", event: "Registrations Open" },
    { date: "10th April 2025", time: "23:59", event: "Registrations Close" },
    {date: "11th April 2025", time: "", event: "Mentorship Session 1" },
    { date: "15th April 2025", time: "", event: "Mentorship Session 2" },
    {date : "20 th April 2025", time: "", event: "Final Submission through Portal"},
    { date: "21st April 2025", time: "", event: "Evaluation and Results" },
];

const prizeData = [
    { position: "1st Prize", money: "INR 5000" },
    { position: "2nd Prize", money: "INR 3000" },
    { position: "3rd Prize", money: "INR 2000" },
];

const Benefits = [
    { sub: "Special research opportunity for top participants post hackathon" },
    { sub: "Special prize for top team with all female participants" },
    { sub: "A surprise prize awarded on the day of evaluation"}
];

const organiser = [
    {name:"Zaid Mahmud",img:`${Zaid}`},
    {name:"Urnisha Pal",img:`${Urnisha}`},
    {name:"Sayan Ganguly",img:`${Sayan}`},
    {name:"Kaustav Das",img:`${Kaustav}`}
]

const collaborators = [
    {name:"Asfak Ali",about:"PhD Scholar,Dept of ETCE Jadavpur University ||  Co founder Deep Duo foundation",img:`${Asfak}`},
    {name:"Diptarka Mandal",about:"Researcher CMATER Lab, Dept of CSE, Jadavpur University",img:`${Diptarka}`},
    {name:"Utathya Aich",about:"Software Engineer || Machine Learning Division, Jadavpur University || CNH India Researcher, CMATER Lab, Dept of CSE, Jadavpur University.",img:`${Udathya}`},
]

const tracks = [
    "Al for Online Safety",
    "AI for Career Safety & Trends",
    "AI for Environmental Safety",
    "AI for Social Impact",
];

const Home = () => {
    const [visibleAbout, isvisibleAbout] = useState(true); 
    const [visibleSchedule, isvisibleSchedule] = useState(true); 
    const [visibleRules, isvisibleRules] = useState(true); 
    const [visibleRewards, isvisibleRewards] = useState(true); 
    const [visibleOrganisers, isvisibleOrganisers] = useState(true);
    const [visibleCollaborators, isvisibleCollaborators] = useState(true); 
    const [visibleContact, isvisibleContact] = useState(true);

    // const [timeLeft, setTimeLeft] = useState(0);

    // useEffect(() => {
    //   const targetDate = new Date("2025-04-10T23:59:59").getTime(); // Move targetDate inside useEffect
    //   const updateTimer = () => {
    //     setTimeLeft(targetDate - new Date().getTime());
    //   };
  
    //   updateTimer(); // Update immediately on mount
    //   const timer = setInterval(updateTimer, 1000);
  
    //   return () => clearInterval(timer);
    // }, []); // No dependencies needed
  
    // const formatTime = (ms) => {
    //   if (ms <= 0) return "00d 00h 00m 00s"; // Handle expiration case
    //   const days = Math.floor(ms / (1000 * 60 * 60 * 24));
    //   const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    //   const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
    //   const seconds = Math.floor((ms % (1000 * 60)) / 1000);
    //   return `${days}d ${hours}h ${minutes}m ${seconds}s`;
    // };

    // const navigate = useNavigate();

    return (
        <div className='bg-gray-900 text-gray-200 min-h-screen font-sans '>
            {/* Header Image */}
            <div className='max-w-screen-lg h-64 bg-gray-900 pt-10 mx-auto  rounded-3xl'>
                <img src={panelImg} alt='banner' className='w-full h-full  rounded-3xl bg-center' />
            </div>

            {/* Main Content */}
            <div className="max-w-screen-lg mx-auto p-6 bg-gray-900 shadow-lg rounded-lg flex flex-col sm:flex-row items-start sm:items-center gap-9">
                {/* Logo */}
                <div className="flex-shrink-0">
                    <img src={Sristi} alt="Ignition Hack" className="w-24 h-24 rounded-full shadow-lg" />
                </div>

                {/* Content */}
                <div className="flex-1 w-full">
                    <h2 className="text-2xl font-bold text-teal-400">Tensor Arena</h2>
                    <div className="flex gap-2 my-2 flex-wrap">
                        <span className="bg-teal-600 text-white text-sm px-4 py-1 rounded-full">#tensorarena</span>
                        <span className="bg-teal-600 text-white text-sm px-4 py-1 rounded-full">#aimlhackathon</span>
                    </div>
                    <p className="text-gray-400 text-base leading-relaxed">
                        1st AI-ML Hackathon of North Bengal
                        <br />
                        Organized by <span className='font-semibold text-white'>Jalpaiguri Government Engineering College</span> in collaboration with <span className='font-semibold text-white'>Deep Duo Foundation</span>
                    </p>
                    <div className="flex items-center gap-4 mt-3 text-gray-400">
                        <FaUsers className="text-lg" />
                        <span className="text-sm">3 - 5 Team Members</span>
                    </div>
                </div>

                {/* Registration */}
                <div className="text-center sm:text-right">
                <div className="text-center text-xl font-bold bg-gray-800 text-white p-4 rounded-lg">
                    {/* Registration closes in: <span className="text-teal-400">{formatTime(timeLeft)}</span> */}
                    Registration Closed
                    </div>
                    {/* <p className="text-gray-400 text-sm uppercase font-semibold">Registration Starts From</p>
                    <p className="text-lg font-bold text-teal-400">FRI MAR 14 2025</p> */}
                    {/* <button className="mt-3 bg-teal-500 text-white px-5 py-2 rounded-lg hover:bg-teal-700 transition-all" onClick={()=>{
                        navigate("/submission")
                    }}>Submit Your Idea</button> */}
                </div>
            </div>

            {/* tracks */}
            <div className="h-fit bg-gray-900 flex flex-col items-center justify-center px-4 py-6 pt-0">
      <h1 className="text-2xl md:text-3xl font-bold text-teal-400 mb-4">
        Hackathon Tracks
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 w-full max-w-4xl">
        {tracks.map((track, index) => (
          <div
            key={index}
            className="bg-teal-600 text-white text-center py-2 px-3 rounded-md shadow-md transition-transform transform hover:scale-105"
          >
            <p className="text-sm font-medium">{track}</p>
          </div>
        ))}
      </div>
    </div>

            {/* About */}
            <div className='bg-gray-900 p-6 rounded-lg max-w-screen-lg mx-auto mt-6 pt-0'>
                <h2 className='text-2xl font-bold text-teal-400 flex justify-start items-center gap-x-2'>
                    <icon onClick={()=>(isvisibleAbout(!visibleAbout))} className="cursor-pointer">
                        {visibleAbout && <MdArrowDropDownCircle />}
                        {!visibleAbout && <IoMdArrowDropupCircle/>}
                        </icon>
                    <span>About</span>
                </h2>
                {
                    !visibleAbout && 
                    <p className='mt-4 text-gray-300 leading-relaxed'>
                    Welcome to a unique extravaganza in the world of AI and ML! Dive into cutting-edge ML challenges, innovate, and compete. Build, learn, and network.
                    </p>
                }
                
            </div>

            {/* Rules */}
            <div className="pt-0 max-w-screen-lg p-6 mx-auto ">
                <h2 className="text-2xl font-bold text-teal-400 text-left flex justify-start items-center gap-x-2">
                <icon onClick={()=>(isvisibleRules(!visibleRules))} className="cursor-pointer">
                        {visibleRules && <MdArrowDropDownCircle />}
                        {!visibleRules && <IoMdArrowDropupCircle/>}
                        </icon>
                    <span>Hackathon Rules</span>
                </h2>
                {!visibleRules &&  <div className="bg-gray-800 mt-10 mb-10 mx-auto flex flex-col items-start p-6 shadow-lg rounded-lg w-[600px]">
                <ul className="list-disc list-inside text-gray-300 text-lg font-semibold space-y-2 text-left">
                    <li>A team must consist of 3-5 members.</li>
                    <li>Cross-college teams are not eligible.</li>
                    <li>The hackathon will fully be in online mode only.</li>
                    <li >Special prize for top team with all female participants.</li>
                </ul>
                </div>}
            </div>

            {/* Schedule */}
            <div className="max-w-screen-lg p-6 mx-auto pt-0">
                <h2 className="text-2xl font-bold text-teal-400 flex justify-start items-center gap-x-2">
                <icon onClick={()=>(isvisibleSchedule(!visibleSchedule))} className="cursor-pointer">
                        {visibleSchedule && <MdArrowDropDownCircle />}
                        {!visibleSchedule && <IoMdArrowDropupCircle/>}
                        </icon>
                    <span>Schedule</span>
                </h2>
                {
                    !visibleSchedule && 
                    <div className="space-y-6 mb-10 mt-10">
                    {scheduleData.map((item, index) => (
                        <div key={index} className="flex flex-col sm:flex-row items-center sm:items-start gap-4">
                            <div className="bg-teal-800 text-white px-5 py-3 rounded-md text-center w-36 shadow-md">
                                <p className="text-sm font-semibold">{item.date}</p>
                            </div>
                            <div className="flex-1 bg-gray-800 shadow-md p-4 rounded-lg w-full">
                                {
                                    item.time!=="" &&
                                    <div className="flex items-center gap-2 text-gray-300 text-sm">
                                        <FaClock className="text-gray-400" />
                                        <span>{item.time}</span>
                                    </div>
                                }
                                
                                <p className="text-lg font-medium mt-1 text-white">{item.event}</p>
                            </div>
                        </div>
                    ))}
                </div>
                }
                
            </div>
                
            {/* Rewards */}
            <div className="max-w-screen-lg p-6 mx-auto pt-0">
                <h2 className="text-2xl font-bold text-teal-400 flex justify-start items-center gap-x-2">
                <icon onClick={()=>(isvisibleRewards(!visibleRewards))} className="cursor-pointer">
                        {visibleRewards && <MdArrowDropDownCircle />}
                        {!visibleRewards && <IoMdArrowDropupCircle/>}
                        </icon>
                    <span>Rewards and Benefits</span>
                </h2>
                {!visibleRewards && <div className='mt-10 flex flex-wrap justify-center gap-6'>
                    {prizeData.map((item, index) => (
                        <div key={index} className='bg-gray-800 w-72 flex flex-col items-center justify-center h-20 shadow-md p-4 rounded-lg'>
                            <p className='text-teal-400 font-bold text-lg'>{item.money}</p>
                            <p className='text-gray-300 text-sm font-bold'>{item.position}</p>
                        </div>
                    ))}
                    {Benefits.map((item, index) => (
                        <div key={index} className='bg-gray-800 w-72 flex flex-col items-center justify-center h-24 shadow-md p-4 rounded-lg'>
                            <p className='text-teal-50 text-center font-semibold'>{item.sub}</p>
                        </div>
                    ))}
                </div>}
            </div>

            {/* Organiser */}
            <div className="max-w-screen-lg p-6 mx-auto pt-0">
                <h2 className="text-2xl font-bold text-teal-400 text-left flex justify-start items-center gap-x-2">
                <icon onClick={()=>(isvisibleOrganisers(!visibleOrganisers))} className="cursor-pointer">
                        {visibleOrganisers && <MdArrowDropDownCircle />}
                        {!visibleOrganisers && <IoMdArrowDropupCircle/>}
                        </icon>
                    <span>Organisers</span>
                </h2>
                {!visibleOrganisers && <div className="flex flex-wrap justify-center gap-6 mt-10 mb-10">
                    {organiser.map((organiser, index) => (
                    <div
                        key={index}
                        className="bg-gray-800 w-72 h-72 flex flex-col items-center justify-center p-6 shadow-md rounded-lg "
                    >
                        <img
                        src={organiser.img}
                        alt={organiser.name}
                        className="w-24 h-24 md:w-32 md:h-32 rounded-full border-4 border-gray-300 shadow-md "
                        />
                        <p className="mt-2 text-lg font-bold text-teal-400">{organiser.name}</p>
                    </div>
                    ))}
                </div>}
                </div>

            {/* collaborators */}
            <div className="max-w-screen-lg h-fit p-6 mx-auto pt-0">
                <h2 className="text-2xl font-bold text-teal-400 text-left flex justify-start items-center gap-x-2">
                <icon onClick={()=>(isvisibleCollaborators(!visibleCollaborators))} className="cursor-pointer">
                        {visibleCollaborators && <MdArrowDropDownCircle />}
                        {!visibleCollaborators && <IoMdArrowDropupCircle/>}
                        </icon>
                    <span>Collaborators</span>
                </h2>
                {!visibleCollaborators && <div className="mt-10 h-fit flex flex-wrap justify-center gap-6">
                    {collaborators.map((organiser, index) => (
                    <div
                        key={index}
                        className="bg-gray-800 w-72 h-80 flex flex-col items-center justify-start p-6 shadow-md rounded-lg "
                    >
                        <img
                        src={organiser.img}
                        alt={organiser.name}
                        className="w-24 h-24 md:w-32 md:h-32 rounded-full border-4 border-gray-300 shadow-md "
                        />
                        <p className="mt-2 text-lg font-bold text-teal-400">{organiser.name}</p>
                        <p className='text-center text-teal-100 mt-2 font-semibold'>{organiser.about}</p>
                    </div>
                    ))}
                </div>}
            </div>

                {/* Contact */}
                <div className="max-w-screen-lg p-6 mx-auto pt-0">
                    <h2 className="text-2xl font-bold text-teal-400 mb-10 text-left flex justify-start items-center gap-x-2">
                    <icon onClick={()=>(isvisibleContact(!visibleContact))} className="cursor-pointer">
                        {visibleContact && <MdArrowDropDownCircle />}
                        {!visibleContact && <IoMdArrowDropupCircle/>}
                        </icon>
                    <span>Contact</span>
                        </h2>
                    {!visibleContact &&
                        <div className="flex flex-col md:flex-row items-center justify-center gap-4">
                        {/* Card for Name & Phone Number */}
                        <div className="bg-gray-800 w-72 flex flex-col items-center justify-center p-6 shadow-md rounded-lg">
                          <p className="text-lg font-bold text-teal-400 mb-2">Zaid Mahmud</p>
                          <p className="text-gray-300 text-sm font-semibold">+91-7595995214</p>
                        </div>
                      
                        {/* Card for Official Email */}
                        <div className="bg-gray-800 w-72 flex flex-col items-center justify-center p-6 shadow-md rounded-lg">
                          <p className="text-lg font-bold text-teal-400 mb-2">Our Official Email</p>
                          <p className="text-gray-300 text-sm font-semibold">sristihackathon@gmail.com</p>
                        </div>
                      </div>
                      
                      }
                </div>
            </div>
    );
};

export default Home;
